// Copyright ©️ 2026 eVolve MEP, LLC

import { FLAT_BLACK_FILLER, type HexTriplet } from '@evolvemep/api-ts';

export const labelTheming = {
  /** The default preferred distance in NDC units from the bend geometry bounding box to a label billboard. */
  defaultPreferredDistance: 0.1,
  /**
   *  The maximum distance in NDC units from the center of the camera to a label billboard.
   *  Used to make sure labels stay inside the camera frustum.
   **/
  maxDistance: 0.9,
  colors: {
    white: '#ffffff' as HexTriplet,
    black: FLAT_BLACK_FILLER as HexTriplet,
    primary: '#007DA3' as HexTriplet,
    primaryLight: '#2FC6F4' as HexTriplet,
    primaryDark: '#054B61' as HexTriplet,
    background: '#ced4da' as HexTriplet,
    backgroundLight: '#e9ecef' as HexTriplet,
    backgroundDark: '#868e96' as HexTriplet,
  },
  lineThickness: {
    veryThick: 8,
    thick: 6,
    normal: 4,
    thin: 2,
  },
  /** Higher render orders appear above lower ones */
  renderOrder: {
    /**
     * Highlighting increases these values, so they should be farther apart than just one.
     * Otherwise, as an example, a connector line might show up above a label billboard when highlighted.
     */
    labelBillboard: 1000,
    connectorLine: 995,
    leaderLine: 990,
    /** Use this for labels that render on top of or very near the bend geometry */
    labelOnBend: 985,
  },
  /**
   * Three.js camera layers used to control label visibility per render mode.
   * See https://threejs.org/docs/#api/en/cameras/Layers.
   */
  layers: {
    /** Use this for labels that only make sense in the front view. */
    front: 1,
    /** Use this for labels that only make sense in the top view. */
    top: 2,
  },
} as const;
